export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Medium-07f0decd27d75ca0935367f9ea3535ec.woff";